/* @flow */

import * as React from 'react'
import styled, { css } from 'styled-components'

import { getDimensionValue, WidgetContainer } from '../shared'
import { addPxToInput } from '../../../../shared'

const WebshopCenteredContentWidget = ({ gridItem, ...rest }) => {
  console.log('ESBEN', gridItem)
  return (
    <StyledWidgetContainer gridItem={gridItem}>
      {gridItem.children.map(childGridItem => {
        const GridItemComponent = childGridItem.component

        if (!GridItemComponent) {
          return null
        }

        return <GridItemComponent gridItem={childGridItem} {...rest} />
      })}
    </StyledWidgetContainer>
  )
}

export default WebshopCenteredContentWidget

const StyledWidgetContainer = styled(WidgetContainer)`
  ${({ gridItem }) => {
    if (gridItem.data.center === 'horizontally') {
      return css`
        display: flex;
        justify-content: center;

        width: ${getDimensionValue(
          gridItem.data.width_mode,
          gridItem.data.fixed_width,
          gridItem.data.parent_percentage_width
        )};
      `
    } else if (gridItem.data.center === 'vertically') {
      return css`
        align-items: center;
        display: flex;

        height: ${getDimensionValue(
          gridItem.data.height_mode,
          gridItem.data.fixed_height,
          gridItem.data.parent_percentage_height
        )};
      `
    }
  }}
`
